/* global graphql */

import React from 'react';
import AOS from 'aos';
import Helmet from 'react-helmet';
import { withPrefix } from 'gatsby-link';
//import questions from '../../data/faq/questions';
import Banner from '../../components/Banner';
import Accordion from '../../components/Accordion';

//import './_privacy-policy.scss';

class FAQPage extends React.Component {
  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }

  render() {
    //console.log(questions);
    return (
      <div class="faq-page">
        <Helmet>
          <title>FAQs | Invest as you spend</title>
          <meta name="description" content="We've got your back. Please reach out if you have any further questions" />
        </Helmet>
        <Banner
          title="Frequently asked questions"
          tagline="We've got your back. Please reach out if you have any further questions."
          />
        <Accordion data={this.props.data.allFaqYaml.edges[0].node.questions} />
        {/* <Accordion data={questions} /> */}
      </div>
    );
  }
}

export default FAQPage;

export const pageQuery = graphql`
query FaqQuestionsQuery {
  allFaqYaml {
    edges {
      node {
        questions {
          group
          faq_list {
            question
            answer
          }
        }
      }
    }
  }
}
`;

// query FaqQuestionsQuery {
//   faqYaml {
//     questions {
//       group
//     }
//   }
// }





// WEBPACK FOOTER //
// ./src/pages/faq/index.js